import MetaInfoListItem from "components/MetaInfoList/Item";
import TriggerByInfo from "components/TriggerByInfo";
import { Run, VcsProvider } from "types/generated";

import RunTriggerCommit from "../RunTriggerCommit";

type RunTriggeredByProps = {
  run: Run;
  stackId: string;
  provider: VcsProvider;
};

const RunTriggeredBy = ({ run, stackId, provider }: RunTriggeredByProps) => (
  <MetaInfoListItem fullWidth>
    <RunTriggerCommit triggeredBy={run.triggeredBy || undefined} />
    <TriggerByInfo
      stackId={stackId}
      triggeredBy={run.triggeredBy || undefined}
      driftDetection={run.driftDetection}
      provider={provider}
      hidePrefix
    />
  </MetaInfoListItem>
);

export default RunTriggeredBy;
